export type TabType = 'brokerages' | 'agents';

export const isTabType = (tab: string): tab is TabType =>
  ['brokerages', 'agents'].includes(tab);

export enum TabMenu {
  Brokerages = 'Brokerages',
  Agents = 'Agents',
}

export type orgType = 'answering' | 'mlsStaff';
